import { render, staticRenderFns } from "./detail-job.vue?vue&type=template&id=4eb01030"
import script from "./detail-job.vue?vue&type=script&lang=js"
export * from "./detail-job.vue?vue&type=script&lang=js"
import style0 from "./detail-job.vue?vue&type=style&index=0&id=4eb01030&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports